import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getOrderDetailsByOrderIdForProvider, saveProviderSignatureForOrder } from "../../../service/ProviderNotificationService";
import { useAppSelector } from "../redux-hooks";
import { CredentailsInfo, UserInfo } from "../manufacturerNotifications/ManufacturerNotificationSlice";
import { InterceptorOption } from "../../../types/CommonTypes";
import { RootState } from "../../store";
import { http } from "../../../service/http";
import { VALIDATE_CREDENTAILS_URL } from "../../../service/URL";


interface ProviderNotificationState {
  orderDetails: any | null;
  isValidCredentials: true | false;
  status: "idle" | "loading" | "success" | "failed";
  error: string | null;
}

// Initial state
const initialState: ProviderNotificationState = {
  orderDetails: null,
  status: "idle",
  error: null,
  isValidCredentials: false,
};

export const getOrderDetailsForProvider = createAsyncThunk('getOrderDetailsForProvider', async (orderId: any) => {
    const response = await getOrderDetailsByOrderIdForProvider(orderId);
    const v3Response = response.data;
    // return v3Response.data;
    return v3Response?.data; // CS-1984
});

export const saveProviderSignAgainstOrder = createAsyncThunk('saveProviderSignAgainstOrder', async (data: any) => {
    const response = await saveProviderSignatureForOrder(data);
    const v3Response = response.data;
    console.log("%c Line:29 🥑 v3Response", "color:#465975", v3Response);
    return v3Response;
});

export const validateProviderCredentials = createAsyncThunk<
    any,
    { loginInfo: CredentailsInfo; interceptorOption?: InterceptorOption },
    { state: RootState; rejectValue: string }
>("validateProviderCredentials", async (data, { rejectWithValue }) => {
    const { loginInfo, interceptorOption } = data;
    try {
        const response = await http.post(VALIDATE_CREDENTAILS_URL, loginInfo, undefined, interceptorOption);
        const resData = response.data;
        return resData.data;
    } catch (error) {
        //@ts-ignore
        return rejectWithValue(error?.data);
    }
});

const providerNotificationSlice = createSlice({
    name: "providerNotification",
    initialState,
    reducers: {
        resetProviderNotificationState: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(getOrderDetailsForProvider.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(getOrderDetailsForProvider.fulfilled, (state, action: PayloadAction<any>) => {
                state.status = "success";
                state.orderDetails = action.payload;
            })
            .addCase(getOrderDetailsForProvider.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message || "Failed to fetch order details";
            })
            .addCase(validateProviderCredentials.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(validateProviderCredentials.fulfilled, (state, action: PayloadAction<UserInfo>) => {
                state.status = "success";
                state.isValidCredentials = true;
            })
            .addCase(validateProviderCredentials.rejected, (state, action) => {
                state.status = "failed";
                state.isValidCredentials = false;
                state.error = action.error.message || "Login failed";
            })
    },
});

// export const { resetProviderNotificationState } = providerNotificationSlice.actions;

export const useProviderNotificationData = () => useAppSelector((state) =>  state.providerNotificationSlice);

export default providerNotificationSlice.reducer;
